// client/src/components/Controls.jsx
import React, { useState } from 'react';
import RecordButton from './RecordButton';
import RaiseHandButton from './RaiseHandButton';

const Controls = ({
  audioEnabled,
  videoEnabled,
  isScreenSharing,
  onToggleAudio,
  onToggleVideo,
  onScreenShare,
  onLeave,
  participantCount = 1,
  onShowParticipants,
  onShowChat,
  chatVisible = false,
  localStream,
  socketRef,
  roomId,
  nickname,
  screenStream,
  onToggleSettings,
}) => {
  const [showMoreOptions, setShowMoreOptions] = useState(false);

  return (
    <div className="zoom-controls-container">
      <div className="controls-center">
        <button
          onClick={onToggleAudio}
          className={`zoom-control-btn ${audioEnabled ? 'active' : 'inactive'}`}
          title={audioEnabled ? 'Mute' : 'Unmute'}
        >
          <span className="control-icon" aria-hidden="true">
            {audioEnabled ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" fill="currentColor"/>
                <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" fill="currentColor"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z" fill="currentColor"/>
              </svg>
            )}
          </span>
          <span className="control-label">{audioEnabled ? 'Mute' : 'Unmute'}</span>
        </button>

        <button
          onClick={onToggleVideo}
          className={`zoom-control-btn ${videoEnabled ? 'active' : 'inactive'}`}
          title={videoEnabled ? 'Stop Video' : 'Start Video'}
        >
          <span className="control-icon" aria-hidden="true">
            {videoEnabled ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" fill="currentColor"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H5.83l2.88-2.88c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L2.29 6.29c-.39.39-.39 1.02 0 1.41L7.3 12.7c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.83 9H16v7.5l4-4V6.5z" fill="currentColor"/>
              </svg>
            )}
          </span>
          <span className="control-label">{videoEnabled ? 'Stop Video' : 'Start Video'}</span>
        </button>

        <button
          onClick={onScreenShare}
          className={`zoom-control-btn ${isScreenSharing ? 'active' : 'inactive'}`}
          title={isScreenSharing ? 'Stop Share' : 'Share Screen'}
        >
          <span className="control-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" fill="currentColor"/>
            </svg>
          </span>
          <span className="control-label">{isScreenSharing ? 'Stop Share' : 'Share Screen'}</span>
        </button>

        <RecordButton 
          localStream={localStream} 
          isScreenSharing={isScreenSharing}
          screenStream={screenStream}
          socketRef={socketRef}
          roomId={roomId}
          nickname={nickname}
        />

        <RaiseHandButton
          socketRef={socketRef}
          roomId={roomId}
          nickname={nickname}
        />

        <button
          onClick={onShowParticipants}
          className="zoom-control-btn participants-btn"
          title="Participants"
        >
          <span className="control-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01.99L14 10.5c-.47-.62-1.21-.99-2.01-.99h-1.54c-.8 0-1.54.37-2.01.99L7 10.5c-.47-.62-1.21-.99-2.01-.99H3.46c-.8 0-1.54.37-2.01.99L0 10.5V22h2v-6h2.5l2.54-7.63A1.5 1.5 0 0 1 7.46 8H9c.8 0 1.54.37 2.01.99L12 10.5c.47.62 1.21.99 2.01.99h1.54c.8 0 1.54.37 2.01.99L18 10.5c.47.62 1.21.99 2.01.99h1.54c.8 0 1.54.37 2.01.99L24 10.5V22h-2v-6h-2.5z" fill="currentColor"/>
            </svg>
          </span>
          <span className="control-label">Participants</span>
          <span className="participant-count">{participantCount}</span>
        </button>

        <button
          onClick={onShowChat}
          className={`zoom-control-btn ${chatVisible ? 'active' : 'inactive'}`}
          title="Chat"
        >
          <span className="control-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" fill="currentColor"/>
            </svg>
          </span>
          <span className="control-label">Chat</span>
        </button>

        <div className="more-options">
          <button
            onClick={() => setShowMoreOptions(!showMoreOptions)}
            className="zoom-control-btn more-btn"
            title="More"
          >
            <span className="control-icon" aria-hidden="true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" fill="currentColor"/>
              </svg>
            </span>
            <span className="control-label">More</span>
          </button>
          
          {showMoreOptions && (
            <div className="more-options-menu">
              <button className="option-item">
                <span className="option-icon">📁</span>
                Share Files
              </button>
              <button className="option-item">
                <span className="option-icon">🎨</span>
                Whiteboard
              </button>
              <button className="option-item" onClick={onToggleSettings}>
                <span className="option-icon">⚙️</span>
                Settings
              </button>
            </div>
          )}
        </div>
      </div>

      <button onClick={onLeave} className="zoom-control-btn leave-btn" aria-label="Leave call">
        <span className="control-icon" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" fill="currentColor"/>
          </svg>
        </span>
        <span className="control-label">Leave</span>
      </button>
    </div>
  );
};

export default Controls;